module.exports = __webpack_public_path__ + "img/mitz_no.a9bd1de2.png";